const CustomCheckbox = {
    props: {
        title: {
            type: String,
            default: "",
        },

        checkboxId: {
            type: String,
            default: "",
        }, 

        checkVar: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            checkbox_value: false,
        };
    },

    created() {
        this.checkbox_value = this.checkVar;
    },

    watch: {
        checkVar: function () {
            this.checkbox_value = this.checkVar;
        },
    },

    methods: {
        onCheckBoxChange(e) {
            this.$emit("on_change", this.checkbox_value, this.checkboxId);
        },
    },

    template: /*html*/ `
    <div class="switch">
      <label>
        <input type="checkbox" :id="checkboxId" @change="onCheckBoxChange" v-model="checkbox_value">
        <div></div>
        <p>{{title}}</p>
      </label>
    </div>
  `,
};

export default CustomCheckbox;
